import Intercom, { update, trackEvent as trackEvenSdk } from "@intercom/messenger-js-sdk";

export const initialiseIntercom = ({
  INTERCOM_APP_ID,
  INTERCOM_HASH,
  user,
  home,
}: {
  INTERCOM_APP_ID: string
  INTERCOM_HASH: string
  user: {
    id: string
    name: {
      first?: string
      last?: string
    }
  }
  home?: {
    id: string
    name: string
  }
}) => {
	Intercom({
		app_id: INTERCOM_APP_ID,
		user_id: user.id,
		user_hash: INTERCOM_HASH,
		name: `${user.name.first || ''} ${user.name.last || ''}`,
		company: home && {
		  id: home.id,
		  name: home.name,
		},
	  })
}

export const showIntercom = () =>
	update({hide_default_launcher: false});
export const hideIntercom = () =>
	update({hide_default_launcher: true});
export const trackEvent = (eventName: string) =>
	trackEvenSdk(eventName)

export default initialiseIntercom
